import {
  API_URL,
  GET_ERRORS,
  IS_LOADING,
  GET_CASES,
  GET_PROJECTS,
  SET_ACTIVE_CHECKBOXES,
  SET_ANALYSIS,
  RESET_ANALYSIS,
} from "./types";
import { tokenConfig } from "../utils/tokenConfig";
import axios from "axios";
import SuccessAlert from "../components/Modals/SuccessAlert";
import ErrorAlert from "../components/Modals/ErrorAlert";
import { resultsKeys } from "../utils/resultsKeys";

// get list of cases and distinct projects
export const getCasesAndProjects = () => async (dispatch) => {
  try {
    const res_cases = await axios.get(`${API_URL}/cases/`, tokenConfig());
    dispatch({
      type: GET_CASES,
      payload: res_cases.data,
    });
    const res_projects = await axios.get(
      `${API_URL}/cases/projects/`,
      tokenConfig()
    );
    dispatch({
      type: GET_PROJECTS,
      payload: res_projects.data,
    });
  } catch (err) {
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    dispatch({
      type: GET_ERRORS,
      payload: errors,
    });
  }
};

export const setActiveCheckboxes =
  (array_checkboxes_updated) => async (dispatch) => {
    dispatch({
      type: SET_ACTIVE_CHECKBOXES,
      payload: array_checkboxes_updated,
    });
  };

export const deleteCases =
  (active_checkboxes, getCasesAndProjects, id_opened_case) =>
  async (dispatch) => {
    try {
      dispatch({
        type: IS_LOADING,
      });
      for (let id of active_checkboxes) {
        await axios.delete(`${API_URL}/cases/${id}/`, tokenConfig());
      }
      // if you are deleting an opened case, reset analysis
      if (active_checkboxes.includes(id_opened_case)) {
        dispatch({
          type: RESET_ANALYSIS,
        });
      }
      getCasesAndProjects();
      dispatch({
        type: IS_LOADING,
      });
      SuccessAlert("Done");
    } catch (err) {
      const errors = {
        msg: err.response.data,
        status: err.response.status,
      };
      dispatch({
        type: GET_ERRORS,
        payload: errors,
      });
    }
  };

export const openCase =
  (id, reset_analysis = true, is_loading = true) =>
  async (dispatch) => {
    try {
      if (reset_analysis) {
        dispatch({
          type: RESET_ANALYSIS,
        });
      }
      if (is_loading) {
        dispatch({
          type: IS_LOADING,
        });
      }
      const res_header = await axios.get(
        `${API_URL}/cases/${id}/`,
        tokenConfig()
      );
      var res = res_header.data;
      // since results are heavy, take only the first key
      var list_get = [];
      var list_results = [resultsKeys[0]];
      list_results.forEach((key) => {
        list_get.push(
          axios.get(`${API_URL}/cases/${id}/results?key=${key}`, tokenConfig())
        );
      });

      await axios
        .all(list_get)
        .then(
          axios.spread((...responses) => {
            responses.forEach((single_res) => {
              res = { ...res, ...single_res.data };
            });
            dispatch({
              type: SET_ANALYSIS,
              payload: res,
            });
            if (is_loading) {
              dispatch({
                type: IS_LOADING,
              });
            }
            SuccessAlert("Case opened successfully");
            return res;
          })
        )
        .catch((errors) => {
          if (is_loading) {
            dispatch({
              type: IS_LOADING,
            });
          }
          ErrorAlert("Cannot open selected case.");
          return false;
        });
    } catch (err) {
      const errors = {
        msg: err.response.data,
        status: err.response.status,
      };
      dispatch({
        type: GET_ERRORS,
        payload: errors,
      });
    }
  };
